import React from "react";
import MultiSeriesSVGContainer from "./MultiSeriesSVGContainer.js";
import MultiSeriesChart from "./MultiSeriesChart.js";
import * as d3 from "d3";
import dynamicProps from "./configStructure.js";
export default class ReactD3MultiSeriesChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = $.extend(
      true,
      {
        componentName: "ReactD3MultiSeriesChart"
      },
      props
    );
    this.components = [];
    AxiomAPIs.registerStateChange(this.props.appName, this.props.appID, this, dynamicProps);
  }

  componentDidCatch(error) {
    console.error(error);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (JSON.stringify(nextState) != JSON.stringify(this.state) || JSON.stringify(nextProps) != JSON.stringify(this.props)) {
      return true;
    } else {
      return false;
    }
  }

  render() {
    return (
      <MultiSeriesSVGContainer childComponentConfigs={this.state.config.childComponentConfigs} width={this.state.config.width || 0} id={this.state.id} height={this.state.config.height || 0}>
         {this.props.children!=null && this.state.children}
        <MultiSeriesChart
          config={$.extend(true,{},this.state.config)}
          id={this.props.id}
          //id={AxiomAPIs.generateUUID()}
          showTooltipDetail={this.state.showTooltipDetail}
          duration={10}
          annotationsData={this.state.annotationsData}
          {...this.state}
        >
        </MultiSeriesChart>
        {
          this.state.config.childComponentConfigs && this.state.config.childComponentConfigs.map((d,index)=>{
            var childComponent=this.state.renderChildComponent(d);
            var width=document.body.clientWidth;
            var height=document.body.clientHeight;
            var innerWidth=childComponent.props.config.width;
            var innerHeight=childComponent.props.config.height;
            var tooltipStyle=d.positionInfo.tooltipStyle || {};
            var parentDiv=this.state.id;
            var translateX=0;
            var translateY=0;
            var y=d.positionInfo.y;
            var x=d.positionInfo.x;
            var bandwidth=parseFloat(d.positionInfo.bandwidth);
            var barHeight=parseFloat(d.positionInfo.barHeight);
            var triangleHeight=15;
            var triangleWidth=10;
            var x1=0,x2=0,x3=0,y1=0,y2=0,y3=0;
            var parentSelector=$("#"+parentDiv).offset();
            var divX=translateX;
            if(x+innerWidth+triangleWidth+bandwidth+parentSelector.left < (width)  ){//&& y-innerHeight-triangleHeight>0
              //CBT:show on right
              translateX=x+bandwidth+triangleWidth;
              translateY=y+(barHeight/2)-(innerHeight/2);
              x1=-triangleWidth;
              y1=(innerHeight/2);
              x2=x1+triangleWidth+1;
              y2=y1-(triangleHeight/2)-2;
              x3=x1+triangleWidth+1;
              y3=y1+(triangleHeight/2)+2;
              divX=translateX;
            }else if((x+parentSelector.left)-innerWidth>0 ) {//&& y-innerHeight-triangleHeight>0
              //CBT:show on left
              translateX=x-innerWidth-triangleWidth;
              translateY=y+(barHeight/2)-(innerHeight/2);
              x1=innerWidth+triangleWidth;
              y1=(innerHeight/2);
              x2=x1-triangleWidth-1;
              y2=y1-(triangleHeight/2)-4;
              x3=x1-triangleWidth-1;
              y3=y1+(triangleHeight/2)+4;
              divX=translateX-3;
            }
            var divY=translateY;
            height=(this.state.config.height-this.state.config.margins.bottom);
            if(divY+innerHeight>(height)){
              divY=(this.state.config.height-this.state.config.margins.bottom)-innerHeight;
            }
            var key='key_'+Math.random();
            key=key.split('.').join("_");
            return (
              <g key={key} className={'multiserie-component-custom-tooltip-onclick'}>
              <g transform={"translate("+translateX+","+translateY+")"}> 
                  <polygon points={x1+","+y1+" "+x2+","+y2+" "+x3+","+y3} style={{fill:tooltipStyle.fill || "rgba(255,255,255,0.9)",fillOpacity:tooltipStyle.fillOpacity || "0.9",stroke:tooltipStyle.stroke || "#ccc"}}  />
              </g>
              <g transform={"translate("+(divX)+","+divY+")"} >
                <rect height={innerHeight} width={innerWidth} rx="10" ry="10" style={$.extend({fill: "black",stroke: "white",strokeWidth: '1.5'},true,(tooltipStyle || {}))}></rect>
                {childComponent}
                <text onClick={this.state.removeChildComponent} y={20} x={innerWidth-20} style={$.extend({cursor:"pointer",fontSize: "20px",fill:"white"},true,(d.positionInfo.closeIconStyle || {}))}>&times;</text>
              </g>
              </g>
            )
          })
        }
      </MultiSeriesSVGContainer>
    );
  }
}